import { SafeStyle } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { HelperService } from '@service/helper.service';
import { Serialize } from 'aautil';

/*
  these are only read from the api
  so no to: params necessary
*/
export class Partnerlogo {
  @Serialize()
  public name: string;

  @Serialize({
    from: {
      map: (imgurl: string, hs: HelperService, self: Partnerlogo) => {
        self.safe = hs.trustStyleURL(environment.backendUrl + imgurl);
        return environment.backendUrl + imgurl;
      },
      deps: [HelperService],
    },
  })
  public imgurl: string;

  @Serialize()
  public link: string;

  public safe: SafeStyle = null;

  @Serialize()
  public lft;

  @Serialize()
  public rgt;

  @Serialize()
  public parent_id;

  @Serialize()
  public depth;
}
